// External components
import React from "react";

// Internal Components
import Overlay from "../../Subcomponents/Overlay/Overlay";
import Modal from "../../Modals/Modal";
import { BsInfoCircleFill } from "react-icons/bs";

import "bootstrap"

const VISIBLE_ITEMS = 11
const HORIZON_MONTHS = 3

export default function ListItemPriority({ data }) {
    const [itemModification, setItemModification] = React.useState({})
    const [showAll, setShowAll] = React.useState(false)

    const horizon = new Date()
    horizon.setMonth(horizon.getMonth() + HORIZON_MONTHS)

    const items = (data || [])
        .filter((item) => !item.date || new Date(item.date).getTime() <= horizon.getTime())
        .sort((a, b) => b.priority - a.priority)

    const visible = items.slice(0, VISIBLE_ITEMS)
    const hidden = items.length - visible.length

    return (
        <div className={"card-container first-component"}>

            {visible.map((item, index) => {
                return (
                    <li className="list-group-item" key={index + item.title} onClick={() => {
                        setItemModification(item.data)
                    }}>
                        <div>
                            <div>
                                {circleColor(item.priority)}
                            </div>
                            <div>
                                <h5>{item.title} - <span className="big-title">{item.subtitle}</span></h5>
                                <button style={{ background: 'none', border: 'none', padding: 0, color: '#069', textDecoration: 'underline', cursor: 'pointer' }} title="" data-tooltip={messagesTooltip(item.messages)} data-tooltip-location="right">
                                    <p className="info">{item.description}<BsInfoCircleFill className="info"></BsInfoCircleFill></p>
                                </button>
                            </div>
                        </div>
                    </li>
                )
            })}

            {hidden > 0 &&
                <li className="list-group-item" key={"more-alerts"} onClick={() => {
                    setShowAll(true)
                }}>
                    <div>
                        <div>
                            {circleColor(items[VISIBLE_ITEMS].priority)}
                        </div>
                        <div>
                            <h5>+{hidden}</h5>
                            <p className="info">Voir toutes les alertes</p>
                        </div>
                    </div>
                </li>
            }

            <Modal show={showAll} title={"Toutes les alertes (" + items.length + ")"}
                close={() => {
                    setShowAll(false)
                }}>
                <ul className={"list-group text-start"}>
                    {items.map((item, index) => {
                        return (
                            <li className={"list-group-item"} key={"all" + index + item.title} onClick={() => {
                                setShowAll(false)
                                setItemModification(item.data)
                            }}>
                                <div className={"d-flex align-items-center gap-2"}>
                                    {circleColor(item.priority)}
                                    <div>
                                        <h5 className={"mb-0"}>{item.title} - <span className="big-title">{item.subtitle}</span></h5>
                                        <p className={"mb-0"}>{item.description}</p>
                                        {(item.messages || []).map((message, messageIndex) => {
                                            return <p className={"mb-0 legend"} key={messageIndex + message}>{message}</p>
                                        })}
                                    </div>
                                </div>
                            </li>
                        )
                    })}
                </ul>
            </Modal>

            <Overlay item={itemModification}
                close={() => {
                    setItemModification(false)
                }}
                edit={(value) => {
                    setItemModification(value)
                }} />
        </div>
    )
}





function circleColor(value) {
    if (value >= 30) {
        return <div className={"colorDiv danger-bg"} />
    }
    if (value >= 10) {
        return <div className={"colorDiv warning-bg"} />
    }
    if (value >= 0) {
        return <div className={"colorDiv success-bg"} />
    } else return <div className={"colorDiv dark-bg"} />
}


function messagesTooltip(messages) {
    let tooltip = ''
    ;(messages || []).forEach(message => tooltip += String(message) + '\n')
    return tooltip
}
